import { getUserAlreadyExist, getValidateCustomerNumber, getValidatePhone, ValidateApiParameter, validateForgotPasswordEmail } from "@dana/Services/DanaValidateCustomerService";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface ValidateCustomerNumberParameter {
    registeredCustomerNumber?: string;
    validateCustomerNumber?: boolean;
    email?: string;
    validateUserEmail?: boolean;
    validateForgotPasswordEmail?: boolean;
    phone?: string;
    validateUserPhone?: boolean;
    onSuccess?: (success?: boolean) => void;
    onError?: (error: string) => void;
}

type HandlerType = ApiHandlerDiscreteParameter<
    ValidateCustomerNumberParameter,
    ValidateApiParameter,
    ServiceResult<boolean>
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        registeredCustomerNumber: props.parameter.registeredCustomerNumber,
        email:props.parameter.email,
        phone:props.parameter.phone
    };
};

export const ValidateCustomerNumber: HandlerType = async props => {
    if (props.parameter.validateCustomerNumber && props.parameter.registeredCustomerNumber !== "") {
        props.apiResult = await getValidateCustomerNumber(props.apiParameter);
    }
};
export const ValidatePhone: HandlerType = async props => {
    if (props.parameter.validateUserPhone && props.parameter.phone !== "") {
        props.apiResult = await getValidatePhone(props.apiParameter);
    }
};
export const ValidateEmail: HandlerType = async props => {
    if (props.parameter.validateUserEmail && props.parameter.email !== "") {
        props.apiResult = await getUserAlreadyExist(props.apiParameter);
    }
};
export const ValidateForgotPasswordEmail: HandlerType = async props => {

    if (props.parameter.validateForgotPasswordEmail && props.parameter.email !== "") {
        props.apiResult = await validateForgotPasswordEmail(props.apiParameter);
    }
};
export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.errorMessage!);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};

export const chain = [
    PopulateApiParameter,
    ValidateCustomerNumber,
    ValidatePhone,
    ValidateEmail,
    ValidateForgotPasswordEmail,
    ExecuteOnErrorCallback,
    ExecuteOnSuccessCallback,
];

const infoValidationHandler = createHandlerChainRunner(chain, "InfoValidationHandler");
export default infoValidationHandler;
